export default __webpack_public_path__ + "static/media/stoner.e53645de.png";